"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Div_1 = __importDefault(require("./Div")); // tslint:disable-next-line:variable-name


var Par = {
  style1: Div_1["default"].style1.withComponent("p"),
  style2: Div_1["default"].style2.withComponent("p"),
  style3: Div_1["default"].style3.withComponent("p"),
  style4: Div_1["default"].style4.withComponent("p"),
  textBody: Div_1["default"].textBody.withComponent("p"),
  textAction: Div_1["default"].textAction.withComponent("p"),
  textHelper: Div_1["default"].textHelper.withComponent("p")
};
/** @component */

exports["default"] = Par;